export default "__VITE_ASSET__CGy8E0NB__"